module.exports = __webpack_public_path__ + "img/carParams.fbdf91cb.png";